import React from 'react'

const AssessmentIcon = props => {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
     
    >
      <path
        d="M0.700781 11.3C0.517448 11.1167 0.425781 10.8873 0.425781 10.612C0.425781 10.3373 0.517448 10.1 0.700781 9.9L6.70078 3.85C6.80078 3.76667 6.90911 3.7 7.02578 3.65C7.14245 3.6 7.26745 3.575 7.40078 3.575C7.53411 3.575 7.66345 3.6 7.78878 3.65C7.91345 3.7 8.01745 3.76667 8.10078 3.85L11.4008 7.15L16.6008 2H15.0008C14.7174 2 14.4801 1.90433 14.2888 1.713C14.0968 1.521 14.0008 1.28333 14.0008 1C14.0008 0.716667 14.0968 0.479 14.2888 0.287C14.4801 0.0956668 14.7174 0 15.0008 0H19.0008C19.2841 0 19.5214 0.0956668 19.7128 0.287C19.9048 0.479 20.0008 0.716667 20.0008 1V5C20.0008 5.28333 19.9048 5.52067 19.7128 5.712C19.5214 5.904 19.2841 6 19.0008 6C18.7174 6 18.4801 5.904 18.2888 5.712C18.0968 5.52067 18.0008 5.28333 18.0008 5V3.4L12.1008 9.3C12.0008 9.4 11.8924 9.47067 11.7758 9.512C11.6591 9.554 11.5341 9.575 11.4008 9.575C11.2674 9.575 11.1424 9.554 11.0258 9.512C10.9091 9.47067 10.8008 9.4 10.7008 9.3L7.40078 6L2.07578 11.325C1.89245 11.5083 1.66745 11.6 1.40078 11.6C1.13411 11.6 0.900781 11.5 0.700781 11.3Z"
        fill="#999fac"
      />
    </svg>
  )
}

export default AssessmentIcon